import { Component } from '@angular/core';
import { LoaderEllipsisComponent } from '@shared/components/loader/ellipsis/ellipsis.component';

@Component({
    selector: 'local-loader',
    imports: [LoaderEllipsisComponent],
    templateUrl: './local-loader.component.html',
    styleUrl: './local-loader.component.scss'
})
export class LocalLoaderComponent {}
